import { DefaultTheme } from 'styled-components';

import { LAST_LINE_WIDTH, LINE_WIDTHS } from './constants';
import { SkeletonRadius } from './types';

/**
 * Width for a standalone placeholder, varied by position so neighbouring rows
 * and cells don't line up into a grid of identical bars. Indexing rather than
 * randomising keeps a given placeholder the same width on every render.
 */
export const getVariedWidth = (index: number) =>
  `${LINE_WIDTHS[index % LINE_WIDTHS.length]}%` as const;

/**
 * Width of the line at `index` in a run of `total` lines. The last line of a
 * multi-line run is short, the way a real paragraph ends.
 */
export const getLineWidth = (index: number, total: number) =>
  total > 1 && index === total - 1 ? `${LAST_LINE_WIDTH}%` : getVariedWidth(index);

export const getRadius = (theme: DefaultTheme, radius: SkeletonRadius) => {
  switch (radius) {
    case 'text':
      return `${theme.shape.borderRadius / 2}px`;
    case 'control':
      return `${theme.shape.borderRadius}px`;
    case 'card':
      return `${theme.shape.borderRadius * 2}px`;
    case 'pill':
      return '999px';
    case 'circle':
      return '50%';
    default:
      return `${theme.shape.borderRadius}px`;
  }
};

/** CSS length from a numeric (pixel) or explicit string dimension. */
export const getLength = (value: number | string | undefined) =>
  typeof value === 'number' ? `${value}px` : value;
